import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const TABS = [
  { key: "", label: "All" },
  { key: "pending", label: "Pending" },
  { key: "approved", label: "Approved" },
  { key: "rejected", label: "Rejected" },
];

const COLORS = {
  pending: "bg-amber-100 text-amber-700",
  approved: "bg-green-100 text-green-700",
  rejected: "bg-red-100 text-red-700",
};

export default function AdminProducts() {
  const [tab, setTab] = useState("pending");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/admin/products${tab ? `?status=${tab}` : ""}`);
      setItems(data);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [tab]);

  const act = async (id, action) => {
    try {
      await api.patch(`/admin/products/${id}`, { action });
      toast.success(`Product ${action}d`);
      load();
    } catch { toast.error("Action failed"); }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="text-xs uppercase tracking-[0.2em] text-[#14A085]">Admin</div>
      <h1 className="font-display text-3xl md:text-4xl text-[#0F3D2E]">Product Submissions</h1>

      <div className="mt-6 flex gap-2 flex-wrap">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} className={`px-4 py-1.5 rounded-full text-sm ${tab===t.key ? "bg-[#0F3D2E] text-white" : "bg-white text-[#0F3D2E] border border-[#E2E8E5] hover:border-[#14A085]"}`} data-testid={`ptab-${t.key || "all"}`}>
            {t.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="mt-8 text-center text-[#3B5249]">Loading…</div>
      ) : items.length === 0 ? (
        <div className="mt-8 rounded-xl border border-dashed border-[#E2E8E5] bg-white p-12 text-center">No products here.</div>
      ) : (
        <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="admin-products-list">
          {items.map((p) => (
            <div key={p.id} className="rounded-xl border border-[#E2E8E5] bg-white overflow-hidden" data-testid={`ap-${p.id}`}>
              <div className="aspect-video overflow-hidden bg-[#F9F9F7]">
                <img src={p.images?.[0] || "https://images.unsplash.com/photo-1561715276-a2d087060f1d"} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`text-xs px-2 py-0.5 rounded-full capitalize ${COLORS[p.status]}`}>{p.status}</span>
                  <span className="text-xs text-[#6E877C]">{p.category}</span>
                </div>
                <div className="font-medium text-[#0F3D2E] line-clamp-2 min-h-[2.5rem]">{p.title}</div>
                <div className="mt-1 text-xs text-[#6E877C]">by {p.vendor_name}</div>
                <div className="mt-1 text-sm text-[#3B5249]">₹{p.price} · MRP ₹{p.mrp} · Stock: {p.stock}</div>
                <div className="mt-3 flex gap-2">
                  {p.status !== "approved" && <button onClick={() => act(p.id, "approve")} className="flex-1 px-3 py-1.5 rounded-full bg-[#0F3D2E] hover:bg-[#14A085] text-white text-sm" data-testid={`approve-p-${p.id}`}>Approve</button>}
                  {p.status !== "rejected" && <button onClick={() => act(p.id, "reject")} className="flex-1 px-3 py-1.5 rounded-full border border-red-300 text-red-600 hover:bg-red-50 text-sm" data-testid={`reject-p-${p.id}`}>Reject</button>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
